import React, { useEffect, useRef, useState } from "react";
import { ArrowButton } from "../../molecules/ArrowButton";

import "primeicons/primeicons.css";
import { BigImgBox } from "molecules/BigImgBox";
import { SectionBorder } from "molecules/SectionBorder";
import Divider from "molecules/SimpleBorder/Divider";
import { fetchAboutOurPeople } from "../../api";





export const TextVideoSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [aboutOurPeopleData, setAboutOurPeopleData] = useState(null);
  const borderRef = useRef(null);
  
  // Fetch about our people data
  useEffect(() => {
    const loadAboutOurPeople = async () => {
      try {
        const data = await fetchAboutOurPeople();
        if (data && data.length > 0) {
          setAboutOurPeopleData(data[0]);
        }
      } catch (error) {
        console.error("Error fetching about our people:", error);
      }
    };
    loadAboutOurPeople();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after visibility
        }
      },
      { threshold: 0.1 } // Trigger when 10% is visible
    );

    if (borderRef.current) {
      observer.observe(borderRef.current);
    }

    return () => {
      if (borderRef.current) {
        observer.unobserve(borderRef.current);
      }
    };
  }, []);

  return (
    <section className=" section-padding p-0 ">
        <div className="container borderSpacing pl-0 pr-0" style={{marginBottom:'42.75px'}}  >

<SectionBorder />
</div>
      <style>
      {`
          @keyframes widthIncrease {
            from {
              width: 10%;
            }
            to {
              width: 100%;
            }
          }

          .animated-border {
            height: 1px; /* Adjust height as needed */
            background-color: black; /* Change this if you want a different color */
            transition: width 0.5s; /* Optional: smooth transition */
          }

          .animated {
            animation: widthIncrease 2s forwards; /* Adjust duration as needed */
          }
        `}
      </style>


 
      <div className="container pl-0  pr-0  "  >
      
       
      <div className="mainHr1" style={{backgroundColor:'transparent'}} />
      {/* <div className="w-100 border-top-1" style={{backgroundColor:'transparent'}} /> */}
{/* <Divider/> */}

        <div className="grid pt-2" style={{ borderColor: "black" }}>
          <div className="lg:col-4 md:col-4 sm:col-12  align-items-center text-2xl p-0">
            <h2 className="section-title " style={{marginTop:'-10px'}}>
              {aboutOurPeopleData?.right_side_main_text ? (
                <span dangerouslySetInnerHTML={{ __html: aboutOurPeopleData.right_side_main_text }} />
              ) : (
                <>
                  Real assets;
                  <br />
                  advised, monitored
                  <br /> and managed
                </>
              )}


          


            </h2>

          </div>
          <div  className="lg:col-8 md:col-6 sm:col-12   font-medium text-justify p-0 pl-1 " style={{fontSize:"18px !important",wordSpacing:"0px"}}>
            <div className="" style={{width:'100%'}}>
            {aboutOurPeopleData?.description ? (
              <p className="details-text mb-4 "  data-aos="fade-up">
                {aboutOurPeopleData.description}
              </p>
            ) : (
              <>
                <p className="details-text mb-4 "  data-aos="fade-up">
                  Quantum Projectinfra Pvt Ltd (Quantum) is a Real Estate Advisor
                  and Manager for End to End Asset Management. Quantum provides
                  services on PAN India basis through its local office presence in
                  all major cities.
                </p>
                <p className="details-text" data-aos="fade-up">
                  Quantum is driven by its Vision statement: "To elevate the
                  professional standards of the Indian realty sector by creating
                  projects that deliver the best value and experience" Quantum
                  imbibes Core Values of "Integrity, Excellence, Team and Trust"
                </p>
              </>
            )}

            <ArrowButton
              width="170"
              buttonText={aboutOurPeopleData?.right_side_link_text || "View all services"}
              bgColor="#CDC08B"
              textColor="#000000"
              url={aboutOurPeopleData?.right_side_link_url || "http://16.170.18.3/our-services"}
            />
            </div>
              <div
              ref={borderRef}
              className={` mt-4 mb-4   animated-border ${isVisible ? "animated" : ""}`}
              style={{ width: isVisible ? "98%" : "10%" }} // Initial width based on visibility
            ></div>
            <div className="pr-1 mb-2 communityImage" style={{ position: 'relative', width: '100%', height: '0', paddingBottom: '56.25%' }}>
    <img 
      src={aboutOurPeopleData?.right_side_media_path || "media/about_banner.png"} 
      className="img-fluid" 
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} 
      alt="About banner"
    />
  </div>
            {/* <BigImgBox imgpath="media/home_about_banner.png" /> */}
          </div>
        </div>
      </div>
     
    </section>
  );
};
